import React from 'react';
import ThinkingStatus from './ThinkingStatus';

const ResultsViewSkeleton: React.FC = () => {
  return (
    <div className="bg-white p-4 sm:p-6 md:p-8 shadow-xl rounded-lg">
      <ThinkingStatus />

      {/* Skeleton Content */}
      <div className="animate-pulse">
        <div className="space-y-8">
          {/* Original Problem Skeleton */}
          <div>
            <div className="h-6 bg-slate-200 rounded-md w-48 mb-4"></div>
            <div className="h-4 bg-slate-200 rounded-md w-32 mb-2"></div>
            <div className="h-4 bg-slate-200 rounded-md w-40 mb-4"></div>
            <div className="bg-slate-200 rounded-lg w-full max-w-md mx-auto h-60 md:h-72"></div>
          </div>

          {/* Solution Block Skeleton */}
          <div className="bg-slate-50 p-4 md:p-6 rounded-lg border border-slate-200">
            <div className="h-7 bg-slate-200 rounded-md w-3/4 mb-6"></div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2 mb-6 border-b border-slate-200 pb-4">
              <div className="space-y-2">
                <div className="h-4 bg-slate-200 rounded w-1/2"></div>
                <div className="h-4 bg-slate-200 rounded w-3/4"></div>
              </div>
              <div className="space-y-2">
                <div className="h-4 bg-slate-200 rounded w-1/2"></div>
                <div className="h-4 bg-slate-200 rounded w-3/4"></div>
              </div>
            </div>
            <div className="space-y-4">
              <div className="h-5 bg-slate-200 rounded w-1/4"></div>
              <div className="h-4 bg-slate-200 rounded w-full"></div>
              <div className="h-4 bg-slate-200 rounded w-5/6"></div>
            </div>
            <div className="mt-6 pt-4 border-t border-slate-200 space-y-4">
              <div className="h-5 bg-slate-200 rounded w-1/3"></div>
              <div className="h-4 bg-slate-200 rounded w-full"></div>
              <div className="h-4 bg-slate-200 rounded w-3/4"></div>
            </div>
          </div>
        </div>

        {/* Share Section Skeleton */}
        <div className="mt-8 pt-6 border-t border-slate-200">
          <div className="h-5 bg-slate-200 rounded-md w-1/4 mx-auto mb-4"></div>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            <div className="h-8 bg-slate-200 rounded-md w-24"></div>
            <div className="h-8 bg-slate-200 rounded-md w-24"></div>
            <div className="h-8 bg-slate-200 rounded-md w-28"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultsViewSkeleton;